import React from 'react'
import "./Walkthrough.css"
import Form from '../Form/Form'
import rimg from "../../Assets/About/contact.jpg"

const Walkthrough = () => {
    return (
        <div className='Walkthrough'>

            <div className='Walkthrough-main'>
                <h2 style={{
                    textAlign: "center",
                    fontSize: "28px",
                    fontWeight: "700",
                    marginBottom: "2rem",
                    color: "#333"
                }}>
                    Need help setting up your sports science lab? Let’s talk.
                </h2>


                <div className="walkthrough-item">

                    <div className="walkthrough-left">
                        <img src={rimg} alt="" />
                    </div>
                    <div className="walkthrough-right">
                        <div className="walkthrough-form">
                            <Form />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Walkthrough
